(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kring-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-kring-sticky]');
    if (!bar) return;
    var show = function () {
      if (window.scrollY > 600) { bar.classList.add('is-visible'); }
      else { bar.classList.remove('is-visible'); }
    };
    show();
    window.addEventListener('scroll', show, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
